import findIndex from 'lodash/findIndex'
import customers from '@/api/customers'
import { AppHolder } from '@/utils/app-holder'

export default () => ({
  namespaced: true,

  state: {
    list: [],
    extraCurrentCustomer: null,
    meta: {},
    stats: {},
    filters: {},
    events: [],
    invitedList: [],
    invitedMeta: {}
  },

  actions: {
    fetch (context, params = { filters: {}, page: undefined }) {
      return customers.fetch(params.filters, params.page)
        .then(data => {
          context.commit('fetch', data)
          context.commit('setFilters', params.filters)
        })
    },
    fetchById ({ state, commit }, { id, cached = true }) {
      if (cached && (state.list.find(customer => customer.id === id) ||
        (state.extraCurrentCustomer && state.extraCurrentCustomer.id === id))) {
        return
      }
      return customers.fetchById(id)
        .then(data => commit('fetchById', data))
    },

    fetchAccounts (context, {id, cached = true}) {
      return customers.fetchAccounts(id)
        .then(data => {
          AppHolder.store.commit('accounts/fetch', data)

          return Promise.all([
            customers.fetchComposition(id, 'bank', 1)
              .then(({ data }) => AppHolder.store.commit('accounts/fetchRepartition', data)),
            customers.fetchComposition(id, 'kind')
              .then(({ data }) => {
                AppHolder.store.commit('contracts/fetchRepartition', data)
              })
          ])
        })
    },

    fetchEvents ({ commit }, id) {
      return customers.fetchEvents(id)
        .then(({ events }) => commit('setEvents', events))
    },

    fetchUser (context, {id, cached = true}) {
      return customers.fetchUser(id)
        .then(data => customers.fetchProfile(id)
          .then(profile => {
            AppHolder.store.commit('user/fetch', Object.assign(data, profile.profile))
          })
        )
    },

    fetchPortfolios (context, {id, cached = true}) {
      return customers.fetchPortfolios(id)
        .then(data => {
          AppHolder.store.commit('contracts/fetch', data)

          return customers.fetchComposition(id, 'contract')
            .then(({ data }) => {
              AppHolder.store.commit('contracts/fetchRepartition', data)
            })
        })
    },

    fetchStats ({ commit }) {
      return customers.fetchStats()
        .then(data => {
          commit('setStats', data)
        })
    },

    fetchNotes ({ commit }, customerId) {
      return customers.fetchNotes(customerId)
        .then(data => {
          commit('setNotes', { customerId, data: data.advisorNotes })
        })
    },

    updateNotes ({ commit }, { customerId, notes }) {
      return customers.updateNotes(customerId, notes)
        .then(data => {
          commit('setNotes', { customerId, data: data.advisorNotes })
        })
    },
    fetchInvited (context, params = { filters: {}, page: undefined }) {
      return customers.fetchInvited(params.filters, params.page)
        .then(data => {
          context.commit('fetchInvited', data)
        })
    },
    createInvitation (context, invitation) {
      return customers.createInvitation(invitation)
    },
    resendInvitation (context, invitationId) {
      return customers.resendInvitation(invitationId)
    },
    cancelInvitation (context, invitationId) {
      return customers.cancelInvitation(invitationId)
        .then(() => context.dispatch('fetchInvited'))
    },

    addEvent ({ commit }, { id, event }) {
      return customers.addEvent(id, event)
        .then(() => customers.fetchEvents(id)
          .then(({ events }) => commit('setEvents', events)))
    },
    deleteEvent (context, { id }) {
      return customers.deleteEvent(id)
    },
    editEvent (context, { id, event }) {
      return customers.editEvent(id, event)
    }
  },

  mutations: {
    fetch (state, data) {
      state.list = data.customers
      state.meta = data.meta
    },
    fetchInvited (state, data) {
      state.invitedList = data.invitations || []
      state.invitedMeta = data.meta || {}
    },
    setFilters (state, filters) {
      state.filters = filters
    },
    fetchById (state, data) {
      state.extraCurrentCustomer = data
    },
    setStats (state, stats) {
      state.stats = stats
    },
    setEvents (state, events) {
      state.events = events
    },
    setNotes (state, { customerId, data }) {
      const index = findIndex(state.list, { id: customerId })
      if (state.extraCurrentCustomer && state.extraCurrentCustomer.id === customerId) {
        state.extraCurrentCustomer = {
          ...state.extraCurrentCustomer,
          advisorNotes: data
        }
      }
      if (index >= 0) {
        state.list = [
          ...state.list.slice(0, index),
          {
            ...state.list[index],
            advisorNotes: data
          },
          ...state.list.slice(index + 1)
        ]
      }
    }
  },

  getters: {
    getById: ({ list, extraCurrentCustomer }) => (id) => {
      return extraCurrentCustomer && extraCurrentCustomer.id === id
        ? extraCurrentCustomer
        : list.find(customer => customer.id === id)
    }
  }
})
